import React from 'react';
import Navbar from '../Home/Navbar';
import "./Viewusers.css"
const Viewusers = ({data}) => {
  
  return (
      <div className="">
          {/* <Navbar/> */}
          <div className="viewuser">

         
      
      <div>

          <h3 style={{"borderBottom":"1px solid grey"}}>Total User: {data.length}</h3>
          <table className="table table-dark my-3">
  <thead>
    <tr>
      <th scope="col">#</th>
      <th scope="col">First</th>
      <th scope="col">Last</th>
      <th scope="col">Email</th>
      
      <th scope="col">Post Count</th>
    </tr>
  </thead>
  <tbody>
    {
      data.map((data1,index)=>{
        return(
    <tr>
      <th scope="row">{index+1}</th>
      <td>{data1.first}</td>
      <td>{data1.last}</td>
      <td>{data1.email}</td>
      
      <td>{data1.postCount}</td>
    </tr>
        )
      })
    
    }
    
  </tbody>
</table>
      </div>
      </div>
      </div>
  )
};

export default Viewusers;
